import { render, staticRenderFns } from "./taxApplySet.vue?vue&type=template&id=35233a6e&scoped=true&"
import script from "./taxApplySet.vue?vue&type=script&lang=js&"
export * from "./taxApplySet.vue?vue&type=script&lang=js&"
import style0 from "./taxApplySet.vue?vue&type=style&index=0&id=35233a6e&prod&lang=scss&scoped=true&"
import style1 from "./taxApplySet.vue?vue&type=style&index=1&id=35233a6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35233a6e",
  null
  
)

export default component.exports